import { createFileRoute } from "@tanstack/react-router";
import MyAssignedTasksPage from "@/pages/MyAssignedTasksPage";

export const Route = createFileRoute("/_app/my-tasks")({
  component: MyAssignedTasksPage,
});
